import style from './main-menu.scss';
import mainMenu from 'Assets/js/main-menu-behavior';

const script = () => {

  mainMenu({
    cssSelector: '.MainMenu',
    itemTriggerSelector: '.MainMenu-trigger',
    linkActiveSelector: '.MainMenu-link.isActive',
  });

};

export {
  style,
  script,
};
